import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import DocumentSignUI from './DocumentSignUI.js'

class DocumentSignSF extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loan: null,
      // html to pdf generation
      generatePGhtml2pdfSubmitted: false,
      generatePGhtml2pdfErrorList: [],
      //
      ldPDFUploadMode: false,
      ldPDFUploadSuccessMsg: null,
      ldPDFUploadErrorList: null,
      ldPDFUploadSubmitted: false,
      //
      loanDocsErrorList: null,
      loanDocsSuccessMsg: null,
      loanDocsSubmitted: false,
      sanctionLetterErrorList: null,
      sanctionLetterSuccessMsg: null,
      sanctionLetterSubmitted: false,
      regenerateLoanDocErrorList: null,
      regenerateLoanDocSuccessMsg: null,
      regenerateLoanDocSubmitted: false,
      selectedDocId: null,
      docSubmitted: false,
      documentList: null,
      downloadRequested: false,
      fileErrorList: null,
      resolutionDateChangeMode: false,
      resolutionUploadMode: false,
      resolutionSubmitted: false,
      resolutionSuccessMsg: null,
      resolutionErrorList: [],

    }
  }

  render() {
    return (
      <DocumentSignUI
        context={this.props.context}
        loan={this.props.loan}
        onRefreshClick={this.props.onRefreshClick}
        // html to pdf generation
        onGeneratePGhtml2pdf={this.onGeneratePGhtml2pdf}
        generatePGhtml2pdfSubmitted={this.state.generatePGhtml2pdfSubmitted}
        generatePGhtml2pdfErrorList={this.state.generatePGhtml2pdfErrorList}
        //
        ldPDFUploadMode={this.state.ldPDFUploadMode}
        onLDPDFUploadClick={this.onLDPDFUploadClick}
        onLDPDFUploadCancel={() => { this.setState({ ldPDFUploadMode: false }) }}
        onLDPDFUpload={this.onLDPDFUpload}
        ldPDFUploadSuccessMsg={this.state.ldPDFUploadSuccessMsg}
        ldPDFUploadErrorList={this.state.ldPDFUploadErrorList}
        ldPDFUploadSubmitted={this.state.ldPDFUploadSubmitted}
        //
        loanDocsErrorList={this.state.loanDocsErrorList}
        loanDocsSuccessMsg={this.state.loanDocsSuccessMsg}
        loanDocsSubmitted={this.state.loanDocsSubmitted}
        onRecreateLoanDocsSubmit={this.onRecreateLoanDocsSubmit}
        sanctionLetterErrorList={this.state.sanctionLetterErrorList}
        sanctionLetterSuccessMsg={this.state.sanctionLetterSuccessMsg}
        sanctionLetterSubmitted={this.state.sanctionLetterSubmitted}
        onRegenerateSanctionLetterSubmit={this.onRegenerateSanctionLetterSubmit}
        onRegenerateResolutionDocSubmit={this.onRegenerateResolutionDocSubmit}
        onRegenerateLoanDocsSubmit={this.onRegenerateLoanDocsSubmit}
        regenerateLoanDocSubmitted={this.state.regenerateLoanDocSubmitted}
        regenerateLoanDocErrorList={this.state.regenerateLoanDocErrorList}
        regenerateLoanDocSuccessMsg={this.state.regenerateLoanDocSuccessMsg}
        selectedDocId={this.state.selectedDocId}
        docSubmitted={this.state.docSubmitted}
        documentList={this.state.documentList}
        onDownloadDocClick={this.onDownloadDocClick}
        downloadRequested={this.state.downloadRequested}
        fileErrorList={this.state.fileErrorList}
        resolutionDateChangeMode={this.state.resolutionDateChangeMode}
        onResolutionDateClick={() => { this.setState({ resolutionDateChangeMode: true }) }}
        onCancelResolutionDateClick={() => { this.setState({ resolutionDateChangeMode: false }) }}
        //Resolution
        resolutionUploadMode={this.state.resolutionUploadMode}
        onUploadResolutionClick={() => { this.setState({ resolutionUploadMode: true }) }}
        onUploadResolutionCancelClick={() => { this.setState({ resolutionUploadMode: false }) }}
        onResolutionUpload={this.onResolutionUpload}
        resolutionErrorList={this.state.resolutionErrorList}
      />
    )
  }

  componentDidMount() {
    this.getDocuments()
  }

  componentDidUpdate(prevProps) {
    if (this.props.loan.loanId !== prevProps.loan.loanId) {
      this.getDocuments()
    }
  }

  // term sheet pdf generat ----------------------------------------------------
  onGenerateTShtml2pdf = () => {
    let submitted = this.state.generateTShtml2pdfSubmitted
    if (submitted)
      return

    this.setState({
      generateTShtml2pdfErrorList: [],
      generateTShtml2pdfSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/termSheet/template/fileDownloadSignedUrl`,
      this.onGenerateTShtml2pdfCallback, {}
    )
  }

  onGenerateTShtml2pdfCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      generateTShtml2pdfErrorList: errorList,
      generateTShtml2pdfSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ generateTShtml2pdfErrorList: [] })
      }, 10000)
    }
  }

  onGeneratePGhtml2pdf = () => {
    let submitted = this.state.generateTShtml2pdfSubmitted
    if (submitted)
      return

    this.setState({
      generatePGhtml2pdfErrorList: [],
      generatePGhtml2pdfSubmitted: true
    })

    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/pledge_cum_guarantee/generated/fileDownloadSignedUrl`,
      this.onGeneratePGhtml2pdfCallback, {}
    )
  }

  onGeneratePGhtml2pdfCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      generatePGhtml2pdfErrorList: errorList,
      generatePGhtml2pdfSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ generatePGhtml2pdfErrorList: [] })
      }, 10000)
    }
  }

  onResolutionUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({ resolutionSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/resolution/pdfDocument/validation`,
      this.onResolutionUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onResolutionUploadCallback = (response) => {
    this.setState({ resolutionSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    if (errorList.length) {
      this.setState({
        resolutionErrorList: errorList
      })
      return
    }

    this.setState({
      resolutionSuccessMsg: response.success,
      resolutionErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          resolutionSuccessMsg: null
        })
      }, 2000)
    }
  }

  onLDPDFUploadClick = (event) => {
    let docId = event.currentTarget.getAttribute('data-row-id')
    this.setState({
      ldPDFUploadMode: true,
      selectedDocId: docId
    })
  }

  onLDPDFUpload = () => {
    this.setState({
      ldPDFUploadSubmitted: true,
      ldPDFUploadSuccessMsg: null,
      ldPDFUploadErrorList: [],
    })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/${this.state.selectedDocId}/pdf/validation`,
      this.onLDPDFUploadCallback, {}
    )
  }

  onLDPDFUploadCallback = (response) => {
    this.setState({ ldPDFUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      ldPDFUploadSuccessMsg: response.success,
      ldPDFUploadErrorList: errorList,
    })

    this.props.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          ldPDFUploadSuccessMsg: null,
        })
      }, 5000)
    }
  }

  onRecreateLoanDocsSubmit = () => {
    let submitted = this.state.loanDocsSubmitted
    if (submitted)
      return

    this.setState({
      loanDocsSuccessMsg: null,
      loanDocsErrorList: [],
      loanDocsSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/esign`,
      this.onRecreateLoanDocsSubmitCallback, {}
    )
  }

  onRecreateLoanDocsSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      loanDocsSuccessMsg: response.success,
      loanDocsErrorList: errorList,
      loanDocsSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          loanDocsSuccessMsg: null
        })
        this.props.onRefreshClick()
      }, 1000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ loanDocsErrorList: [] })
      }, 5000)
    }
  }

  onRegenerateSanctionLetterSubmit = () => {
    let submitted = this.state.sanctionLetterSubmitted
    if (submitted)
      return

    this.setState({
      sanctionLetterSuccessMsg: null,
      sanctionLetterErrorList: [],
      sanctionLetterSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/sanction/esign`,
      this.onRegenerateSanctionLetterSubmitCallback, {}
    )
  }

  onRegenerateSanctionLetterSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      sanctionLetterSuccessMsg: response.success,
      sanctionLetterErrorList: errorList,
      sanctionLetterSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          sanctionLetterSuccessMsg: null
        })
        this.props.onRefreshClick()
      }, 1000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ sanctionLetterErrorList: [] })
      }, 5000)
    }
  }

  onRegenerateLoanDocsSubmit = (event) => {
    let docId = event.currentTarget.getAttribute('data-row-id')

    let submitted = this.state.regenerateLoanDocSubmitted
    if (submitted)
      return

    this.setState({
      regenerateLoanDocSuccessMsg: null,
      regenerateLoanDocErrorList: [],
      regenerateLoanDocSubmitted: true,
      selectedDocId: docId,
      docSubmitted: true
    })

    console.log("hello", this.props)
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/${docId}/esign`,
      this.onRegenerateLoanDocsSubmitCallback, {}
    )
  }

  onRegenerateLoanDocsSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      regenerateLoanDocSuccessMsg: response.success,
      regenerateLoanDocErrorList: errorList,
      regenerateLoanDocSubmitted: false,
      //selectedDocId: null,
      docSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          regenerateLoanDocSuccessMsg: null,
          selectedDocId: null
        })
        this.props.onRefreshClick('noBusy')
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ regenerateLoanDocErrorList: [] })
      }, 5000)
    }
  }

  getDocuments = () => {
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/generated`,
      this.getDocumentsCallback, null, null
    )
  }

  getDocumentsCallback = (response) => {
    let documentList = response.documentList
    this.setState({
      documentList: documentList
    })
  }

  onDownloadDocClick = (event) => {
    let documentId = event.currentTarget.getAttribute('data-type')
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/documents/${documentId}/fileDownloadSignedUrl`,
      this.onDownloadDocClickCallback, null, null
    )
  }

  onDownloadDocClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default DocumentSignSF

